// @flow strict

import * as React from 'react';

function FournisseursPage() {
    return (
        <div>
            <h1 className="font-poppins font-semibold text-[18px] text-title mb-4">
                Fournisseurs
            </h1>
            <p className="font-nunito text-[14px] text-text">
                Gestion des fournisseurs et partenaires
            </p>
        </div>
    );
};

export default FournisseursPage;